import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { common, financedEmissions } from "../../i18n";

interface Props {
  title: string;
}

/** Temporary placeholder for Cat15 pages not yet implemented. */
const ComingSoon = ({ title }: Props) => {
  const { t } = useTranslation([financedEmissions, common], {
    nsMode: "fallback",
  });
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="8px"
      py="80px"
      border="1px dashed var(--gray5)"
      borderRadius="8px"
      bgcolor="var(--white)"
    >
      <Typography variant="h2">{t(title)}</Typography>
      <Typography variant="body1" color="var(--gray1)">
        {t("Coming-Soon")}
      </Typography>
    </Box>
  );
};

export default ComingSoon;
